var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69492 13.0857C7.69492 13.4624 7.26486 13.6774 6.96349 13.4514L0.670158 8.73141C0.182538 8.3657 0.182539 7.63427 0.670158 7.26856L6.96349 2.54856C7.26486 2.32253 7.69492 2.53757 7.69492 2.91427V5.74999C11.8159 5.74999 15.6229 8.95477 15.6955 13.1187C15.6994 13.3434 15.4032 13.4174 15.2721 13.2348C13.9786 11.4344 11.7845 10.25 9.29492 10.25H7.69492V13.0857Z",
    fill: "#A1A8B3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.f3dd64382ae29bd6513f0070801acc68.svg";
export { ForwardRef as ReactComponent };